<template>
<v-main>
  <v-layout justify-center class="mt-2">
    <v-card width="1200" class="rounded-xl">

        <h1>
           <p class="text-center font-weight-bold">Alterar Etiqueta da Unidade</p>
          <!-- {{recepcionista}} -->
        </h1>

    <v-layout column class="mx-4">
        <v-text-field v-model="nomeUnidade" disabled :type="'text'" name="input-10-1" label="Unidade" counter @click:append="show1 = !show1"></v-text-field>
        <v-form v-model="valid" ref="form">
          <v-text-field label="Nome da Etiqueta" v-model="nomeEtiqueta" :rules="nameCompleto" required></v-text-field>

          <v-checkbox label="Voce Concorda?" v-model="checkbox" :rules="[(v) => !!v || 'Voce deve concordar para submeter !']" required></v-checkbox>

          <v-alert :value="erroLogin" color="error" icon="warning" outlined>
            Username já existente !!
          </v-alert>

          <v-alert :value="sucessoLogin" color="success" icon="check_circle" outlined>
            Etiqueta alterada com sucesso !!
          </v-alert>
        </v-form>
    </v-layout>
    <v-card-actions>
      <v-spacer />
       <v-btn rounded dark @click="submit" :class="{ red: !valid, green: valid }">Salvar</v-btn>
          <v-btn text @click="" to='/listaUnidade'>
            <v-icon left>keyboard_backspace</v-icon>
            voltar
          </v-btn>
    </v-card-actions>
    </v-card>
  </v-layout>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorService from '../../../services/administrador.service'

export default {
  name: 'cadastrarAdministrador',
  data () {
    return {
      show1: false,
      nomeEtiqueta: '',
      nomeUnidade: 'teste',
      valid: false,
      erroLogin: false,
      sucessoLogin: false,
      senha: '',
      respostaServidor: '',
      idUnidadeEscolhida: '',
      username: '',
      nome: '',
      nomeUnidade: '',
      // listaUnidades:[],
      listaUnidades: [{
        nomeUnidade: 'unidade 1',
        idUnidade: 1
      }, {
        nomeUnidade: 'unidade 2',
        idUnidade: 2
      }, {
        nomeUnidade: 'unidade 3',
        idUnidade: 3
      }],
      rules: {
        min: v => v.length >= 8 || 'minimo 8 caracteres'
      },
      senhaRules: [
        (v) => v && v.length > 4 || 'senha deve ter mais de 4 digitos'
      ],
      nameRules: [
        (v) => !!v || 'Nome obrigatório',
        (v) => v && v.length > 5 || 'Username deve ter mais de 5 caracteres '
      ],
      nameCompleto: [
        (v) => !!v || 'Nome completo obrigatório',
        (v) => v && v.length > 5 || 'deve ter mais de 5 caracteres '
      ],
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4'
      ],
      checkbox: false

    }
  },
  components: {
    // HelloWorld
  },
  methods: {
    // isDisabled(){
    //   return this.nome !== '' && this.senha !== '' && this.idUnidadeEscolhida !== '';
    // },
    clear () {
      this.$refs.form.reset()
    },

    submit () {
      if (this.$refs.form.validate()) {
        console.log('form valido')
        administradorService.administrador
          .alterarNomeUnidadeEtiqueta(this.idUnidadeEscolhida, this.nomeEtiqueta)
          .then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data)

            if (rsp.data == true) {
              this.sucessoLogin = true
              this.clear()
              setTimeout(() => this.$router.push({
                path: '/listaUnidade'
              }), 2000)
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    limpar () {
      this.senha = ''
      this.nome = ''
      this.idUnidadeEscolhida = ''
      // this.checkbox = null
      // this.$validator.reset()
    },

    retornarUnidades () {
      console.log('em retornar unidades adm...')
      administradorService.administrador
        .retornarUnidades()
        .then(rsp => {
          console.log('rsp oi:')
          this.listaUnidades = rsp.data
          console.log(rsp.data.listaUnidades)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    procurarNomeUnidade () {
      console.log('em procurar nome unidade')
      this.listaUnidades.forEach(unidade => {
        if (unidade.idUnidade == this.idUnidadeEscolhida) {
          console.log('encontrei undidade')
          console.log(unidade.nomeUnidade)
        }
      })
    }

  },
  created () {
    console.log('created...')
  },
  mounted () {
    console.log('em mounted editar etiquerta..')
    if (!this.$route.params.item) {
      this.$router.push('/listaUnidades')
      return
    }
    console.log(this.$route.params.item)
    this.limpar()
    this.nomeUnidade = this.$route.params.item.nomeUnidade
    this.idUnidadeEscolhida = this.$route.params.item.idUnidade
    this.nomeEtiqueta = this.$route.params.item.nomeUnidadeEtiqueta
    this.username = this.$route.params.item.username
    this.user = this.$store.getters.usuario
  }
}
</script>
